window.BusinessBundleData = {
    "bundles": {
        "beauty-hair": {
            "id": "beauty-hair",
            "label": "Beauty & Hair Services",
            "details": {
                "title": "Grow Your Instagram & Get More Reviews",
                "description": "Build your social presence and reputation to attract more clients.",
                "features": [
                    {
                        "title": "Grow Instagram Following",
                        "description": "One tap and clients follow you, see your work, and engage with your content.",
                        "icon": "camera"
                    },
                    {
                        "title": "Get More Google Reviews",
                        "description": "Reviews drive local search rankings.",
                        "icon": "star"
                    },
                    {
                        "title": "Professional Image",
                        "description": "Modern NFC technology shows you're established.",
                        "icon": "award"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "nails-aesthetics": {
            "id": "nails-aesthetics",
            "label": "Nails & Aesthetics",
            "details": {
                "title": "Showcase Your Work & Build Your Brand",
                "description": "Instagram-driven marketing with effortless reviews.",
                "features": [
                    {
                        "title": "Grow Instagram Following",
                        "description": "Showcase your work and build a loyal following with one-tap Instagram access.",
                        "icon": "camera"
                    },
                    {
                        "title": "Get More Google Reviews",
                        "description": "Effortless reviews mean better local rankings and more clients.",
                        "icon": "star"
                    },
                    {
                        "title": "Professional Image",
                        "description": "Stand out with modern NFC technology that shows attention to detail.",
                        "icon": "award"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "health-medical": {
            "id": "health-medical",
            "label": "Health & Medical",
            "details": {
                "title": "Build Trust Through Patient Reviews",
                "description": "Reviews drive patient trust.",
                "features": [
                    {
                        "title": "Increase Patient Reviews",
                        "description": "More reviews mean more trust. Make it effortless for patients to share their experience.",
                        "icon": "star"
                    },
                    {
                        "title": "Professional Presentation",
                        "description": "Modern NFC technology shows you're at the forefront of healthcare.",
                        "icon": "award"
                    },
                    {
                        "title": "Patient Engagement",
                        "description": "Connect with patients and encourage them to follow your practice.",
                        "icon": "users"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "fitness-wellness": {
            "id": "fitness-wellness",
            "label": "Fitness & Wellness",
            "details": {
                "title": "Grow Your Community & Get Reviews",
                "description": "Build a strong social presence.",
                "features": [
                    {
                        "title": "Build Your Community",
                        "description": "Grow your social following and keep members engaged with your content.",
                        "icon": "users"
                    },
                    {
                        "title": "Get More Reviews",
                        "description": "Reviews help attract new members and build credibility.",
                        "icon": "star"
                    },
                    {
                        "title": "Modern Experience",
                        "description": "Show you're forward-thinking with modern NFC technology.",
                        "icon": "award"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "food-beverage": {
            "id": "food-beverage",
            "label": "Food & Beverage",
            "details": {
                "title": "Drive Reviews & Social Engagement",
                "description": "Reviews and social presence drive customers.",
                "features": [
                    {
                        "title": "Get More Reviews",
                        "description": "Google and TripAdvisor reviews are critical for food businesses. Make it effortless.",
                        "icon": "star"
                    },
                    {
                        "title": "Build Social Following",
                        "description": "Showcase your dishes and engage customers on Instagram.",
                        "icon": "camera"
                    },
                    {
                        "title": "Professional Touch",
                        "description": "Modern NFC technology shows attention to detail and quality.",
                        "icon": "award"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "retail-shopping": {
            "id": "retail-shopping",
            "label": "Retail & Shopping",
            "details": {
                "title": "Drive Social Sales & Customer Loyalty",
                "description": "Social media drives modern retail success.",
                "features": [
                    {
                        "title": "Grow Instagram Sales",
                        "description": "Turn every customer into a follower. Showcase products and drive online sales.",
                        "icon": "camera"
                    },
                    {
                        "title": "Get More Reviews",
                        "description": "Reviews build trust and drive foot traffic to your store.",
                        "icon": "star"
                    },
                    {
                        "title": "Customer Engagement",
                        "description": "NFC keychains make perfect customer gifts that keep you top of mind.",
                        "icon": "gift"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "tattoo-body-art": {
            "id": "tattoo-body-art",
            "label": "Tattoo & Body Art",
            "details": {
                "title": "Showcase Your Portfolio & Grow Your Following",
                "description": "Instagram is your portfolio.",
                "features": [
                    {
                        "title": "Grow Instagram Portfolio",
                        "description": "Every client becomes a follower. Showcase your work and attract new clients.",
                        "icon": "camera"
                    },
                    {
                        "title": "Get More Reviews",
                        "description": "Reviews build trust for new clients considering their first tattoo.",
                        "icon": "star"
                    },
                    {
                        "title": "Memorable Giveaways",
                        "description": "Tattoo-themed keychains make perfect gifts for clients.",
                        "icon": "gift"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "automotive": {
            "id": "automotive",
            "label": "Automotive Services",
            "details": {
                "title": "Build Trust Through Reviews",
                "description": "Reviews drive automotive service bookings.",
                "features": [
                    {
                        "title": "Get More Reviews",
                        "description": "Customers trust reviews when choosing automotive services. Make it effortless.",
                        "icon": "star"
                    },
                    {
                        "title": "Build Reputation",
                        "description": "More reviews mean better local rankings and more bookings.",
                        "icon": "award"
                    },
                    {
                        "title": "Customer Loyalty",
                        "description": "NFC keychains keep your business top of mind for repeat service.",
                        "icon": "refresh-cw"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "home-professional-services": {
            "id": "home-professional-services",
            "label": "Home & Professional Services",
            "details": {
                "title": "Grow Through Reviews & Referrals",
                "description": "Reviews drive new business.",
                "features": [
                    {
                        "title": "Get More Reviews",
                        "description": "Service providers live and die by reviews. Make leaving a review effortless.",
                        "icon": "star"
                    },
                    {
                        "title": "Build Trust",
                        "description": "More reviews mean more trust and higher conversion rates.",
                        "icon": "shield"
                    },
                    {
                        "title": "Stay Top of Mind",
                        "description": "NFC keychains ensure customers remember you for future needs.",
                        "icon": "award"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        },
        "hospitality-events-specialty": {
            "id": "hospitality-events-specialty",
            "label": "Hospitality, Events & Specialty",
            "details": {
                "title": "Drive Bookings Through Reviews",
                "description": "Reviews drive bookings.",
                "features": [
                    {
                        "title": "Get More Bookings",
                        "description": "Reviews on Google and TripAdvisor directly impact booking decisions.",
                        "icon": "star"
                    },
                    {
                        "title": "Build Social Presence",
                        "description": "Showcase your work and engage with potential clients on social media.",
                        "icon": "camera"
                    },
                    {
                        "title": "Memorable Experience",
                        "description": "NFC keychains make thoughtful gifts that keep you top of mind.",
                        "icon": "gift"
                    }
                ]
            },
            "availableProducts": [
                {
                    "handle": "google-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "category": "cards",
                    "recommended": true,
                    "defaultQuantity": 2,
                    "basePrice": 19.99
                },
                {
                    "handle": "google-nfc-stand-light",
                    "category": "stands",
                    "recommended": true,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-nfc-stand-dark",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "instagram-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-nfc-stand",
                    "category": "stands",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-light",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-dark",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "google-sticky-nfc-table-plate-colourful",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "facebook-sticky-nfc-table-plate",
                    "category": "plates",
                    "recommended": false,
                    "defaultQuantity": 1,
                    "basePrice": 39.99
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "category": "keychains",
                    "recommended": true,
                    "defaultQuantity": 3,
                    "basePrice": 12.99
                }
            ],
            "starterBundle": [
                {
                    "handle": "google-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "instagram-nfc-review-card",
                    "quantity": 2
                },
                {
                    "handle": "KEYCHAIN_PLACEHOLDER",
                    "quantity": 3
                }
            ]
        }
    },
    "businessTypes": [{
    "id": "distillery",
    "label": "Distillery",
    "bundleRef": "food-beverage",
    "primaryKeychain": "beverage-nfc-keychain"
},{
    "id": "cafe",
    "label": "Cafe",
    "bundleRef": "food-beverage",
    "primaryKeychain": "coffee-nfc-keychain"
},{
    "id": "pet groomer",
    "label": "Pet Groomer",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "dog-groomer-nfc-keychain"
},{
    "id": "make-up artist",
    "label": "Make-Up Artist",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "landscaping supply shop",
    "label": "Landscaping Supply Shop",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "tree-nfc-keychain"
},{
    "id": "medical spa",
    "label": "Medical Spa",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "hair stylist",
    "label": "Hair Stylist",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "pink-hair-dryer-nfc-keychain"
},{
    "id": "coffee shop",
    "label": "Coffee Shop",
    "bundleRef": "food-beverage",
    "primaryKeychain": "coffee-nfc-keychain"
},{
    "id": "clothing brand",
    "label": "Clothing Brand",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "sewing-machine-nfc-keychain"
},{
    "id": "beauty salon",
    "label": "Beauty Salon",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "pink-hair-dryer-nfc-keychain"
},{
    "id": "skin care clinic",
    "label": "Skin Care Clinic",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "photographer",
    "label": "Photographer",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "camera-nfc-keychain"
},{
    "id": "nail salon",
    "label": "Nail Salon",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "pink-nail-polish-nfc-keychain"
},{
    "id": "fitness centre",
    "label": "Fitness Centre",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "fish and chips takeaway",
    "label": "Fish And Chips Takeaway",
    "bundleRef": "food-beverage",
    "primaryKeychain": "beverage-nfc-keychain"
},{
    "id": "hairdresser",
    "label": "Hairdresser",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "pink-hair-dryer-nfc-keychain"
},{
    "id": "sandwich shop",
    "label": "Sandwich Shop",
    "bundleRef": "food-beverage",
    "primaryKeychain": "beverage-nfc-keychain"
},{
    "id": "driving school",
    "label": "Driving School",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "traffic-cone-nfc-keychain"
},{
    "id": "arborist",
    "label": "Arborist",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "tree-nfc-keychain"
},{
    "id": "board game",
    "label": "Board Game",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "vehicle repair shop",
    "label": "Vehicle Repair Shop",
    "bundleRef": "automotive",
    "primaryKeychain": "wrench-nfc-keychain"
},{
    "id": "nail artist",
    "label": "Nail Artist",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "pink-nail-polish-nfc-keychain"
},{
    "id": "pharmacy",
    "label": "Pharmacy",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "barber",
    "label": "Barber",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "barber-pole-nfc-keychain"
},{
    "id": "dj",
    "label": "Dj",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "microphone-nfc-keychain"
},{
    "id": "education centre",
    "label": "Education Centre",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "restaurant",
    "label": "Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "car detailing",
    "label": "Car Detailing",
    "bundleRef": "automotive",
    "primaryKeychain": "tyre-nfc-keychain"
},{
    "id": "vitamin & supplements shop",
    "label": "Vitamin & Supplements Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "notary public",
    "label": "Notary Public",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "wine-glass-nfc-keychain"
},{
    "id": "motor vehicle dealer",
    "label": "Motor Vehicle Dealer",
    "bundleRef": "automotive",
    "primaryKeychain": "nissan-gt-r-r35-nfc-keychain"
},{
    "id": "artist",
    "label": "Artist",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "microphone-nfc-keychain"
},{
    "id": "health and beauty shop",
    "label": "Health And Beauty Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "event planner",
    "label": "Event Planner",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "handmade crafts",
    "label": "Handmade Crafts",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "yarn-ball-nfc-keychain"
},{
    "id": "musician",
    "label": "Musician",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "vinyl-nfc-keychain"
},{
    "id": "antiques",
    "label": "Antiques",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "law firm",
    "label": "Law Firm",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "pub",
    "label": "Pub",
    "bundleRef": "food-beverage",
    "primaryKeychain": "wine-glass-nfc-keychain"
},{
    "id": "barbershop",
    "label": "Barbershop",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "barber-pole-nfc-keychain"
},{
    "id": "eyelash extension clinic",
    "label": "Eyelash Extension Clinic",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "accountant",
    "label": "Accountant",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "jewellery shop",
    "label": "Jewellery Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "motor vehicle parts supplier",
    "label": "Motor Vehicle Parts Supplier",
    "bundleRef": "automotive",
    "primaryKeychain": "wrench-nfc-keychain"
},{
    "id": "dentist",
    "label": "Dentist",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "mobile hairdresser",
    "label": "Mobile Hairdresser",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "pink-hair-dryer-nfc-keychain"
},{
    "id": "massage therapist",
    "label": "Massage Therapist",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "event venue",
    "label": "Event Venue",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "painting services",
    "label": "Painting Services",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "paint-brush-nfc-keychain"
},{
    "id": "carpet and rug shop",
    "label": "Carpet And Rug Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "financial institution",
    "label": "Financial Institution",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "bar",
    "label": "Bar",
    "bundleRef": "food-beverage",
    "primaryKeychain": "wine-glass-nfc-keychain"
},{
    "id": "private health insurance",
    "label": "Private Health Insurance",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "spa",
    "label": "Spa",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "takeout restaurant",
    "label": "Takeout Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "chiropractor",
    "label": "Chiropractor",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "electrical contractor",
    "label": "Electrical Contractor",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "clothing shop",
    "label": "Clothing Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "sewing-machine-nfc-keychain"
},{
    "id": "veterinarian",
    "label": "Veterinarian",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "dog-groomer-nfc-keychain"
},{
    "id": "electrician",
    "label": "Electrician",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "builder",
    "label": "Builder",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "winery",
    "label": "Winery",
    "bundleRef": "food-beverage",
    "primaryKeychain": "wine-glass-nfc-keychain"
},{
    "id": "beauty products retailer",
    "label": "Beauty Products Retailer",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "real estate agency",
    "label": "Real Estate Agency",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "electronics shop",
    "label": "Electronics Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "home improvement shop",
    "label": "Home Improvement Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "gym",
    "label": "Gym",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "tanning salon",
    "label": "Tanning Salon",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "tire dealer",
    "label": "Tire Dealer",
    "bundleRef": "automotive",
    "primaryKeychain": "tyre-nfc-keychain"
},{
    "id": "night club",
    "label": "Night Club",
    "bundleRef": "food-beverage",
    "primaryKeychain": "microphone-nfc-keychain"
},{
    "id": "pet shop",
    "label": "Pet Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "dog-groomer-nfc-keychain"
},{
    "id": "plumber",
    "label": "Plumber",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "cleaning service",
    "label": "Cleaning Service",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "cleaning-spray-nfc-keychain"
},{
    "id": "personal trainer",
    "label": "Personal Trainer",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "beauty consultant",
    "label": "Beauty Consultant",
    "bundleRef": "beauty-hair",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "live music venue",
    "label": "Live Music Venue",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "microphone-nfc-keychain"
},{
    "id": "martial arts school",
    "label": "Martial Arts School",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "pilates studio",
    "label": "Pilates Studio",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "bakery",
    "label": "Bakery",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "tattoo artist",
    "label": "Tattoo Artist",
    "bundleRef": "tattoo-body-art",
    "primaryKeychain": "tattoo-machine-nfc-keychain"
},{
    "id": "hair care shop",
    "label": "Hair Care Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "pink-hair-dryer-nfc-keychain"
},{
    "id": "butcher shop",
    "label": "Butcher Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "interior designer",
    "label": "Interior Designer",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "brow bar",
    "label": "Brow Bar",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "yoga studio",
    "label": "Yoga Studio",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "bridal shop",
    "label": "Bridal Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "landscape designer",
    "label": "Landscape Designer",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "tree-nfc-keychain"
},{
    "id": "men's clothing shop",
    "label": "Men'S Clothing Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "sewing-machine-nfc-keychain"
},{
    "id": "thai restaurant",
    "label": "Thai Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "dermatologist",
    "label": "Dermatologist",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "day spa",
    "label": "Day Spa",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "tattoo shop",
    "label": "Tattoo Shop",
    "bundleRef": "tattoo-body-art",
    "primaryKeychain": "tattoo-machine-nfc-keychain"
},{
    "id": "cosmetics shop",
    "label": "Cosmetics Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "dry cleaner",
    "label": "Dry Cleaner",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "cleaning-spray-nfc-keychain"
},{
    "id": "auto repair",
    "label": "Auto Repair",
    "bundleRef": "automotive",
    "primaryKeychain": "wrench-nfc-keychain"
},{
    "id": "shoe shop",
    "label": "Shoe Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "gift shop",
    "label": "Gift Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "optometrist",
    "label": "Optometrist",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "locksmith",
    "label": "Locksmith",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "tailor",
    "label": "Tailor",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "sewing-machine-nfc-keychain"
},{
    "id": "insurance company",
    "label": "Insurance Company",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "florist",
    "label": "Florist",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "tree-nfc-keychain"
},{
    "id": "auto tune up service",
    "label": "Auto Tune Up Service",
    "bundleRef": "automotive",
    "primaryKeychain": "wrench-nfc-keychain"
},{
    "id": "music school",
    "label": "Music School",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "vinyl-nfc-keychain"
},{
    "id": "italian restaurant",
    "label": "Italian Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "travel agency",
    "label": "Travel Agency",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "boutique",
    "label": "Boutique",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "sewing-machine-nfc-keychain"
},{
    "id": "nail technician",
    "label": "Nail Technician",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "pink-nail-polish-nfc-keychain"
},{
    "id": "toy shop",
    "label": "Toy Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "skin care products vending machine",
    "label": "Skin Care Products Vending Machine",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "lawyer",
    "label": "Lawyer",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "book shop",
    "label": "Book Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "convenience shop",
    "label": "Convenience Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "fast food restaurant",
    "label": "Fast Food Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "insurance broker",
    "label": "Insurance Broker",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "pizza delivery",
    "label": "Pizza Delivery",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "health food shop",
    "label": "Health Food Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "auto body shop",
    "label": "Auto Body Shop",
    "bundleRef": "automotive",
    "primaryKeychain": "wrench-nfc-keychain"
},{
    "id": "bicycle shop",
    "label": "Bicycle Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "interior design",
    "label": "Interior Design",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "eyebrow threading clinic",
    "label": "Eyebrow Threading Clinic",
    "bundleRef": "nails-aesthetics",
    "primaryKeychain": "lips-nfc-keychain"
},{
    "id": "general practitioner",
    "label": "General Practitioner",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "body piercing studio",
    "label": "Body Piercing Studio",
    "bundleRef": "tattoo-body-art",
    "primaryKeychain": "tattoo-machine-nfc-keychain"
},{
    "id": "auto parts shop",
    "label": "Auto Parts Shop",
    "bundleRef": "automotive",
    "primaryKeychain": "wrench-nfc-keychain"
},{
    "id": "pizza restaurant",
    "label": "Pizza Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "sunglasses shop",
    "label": "Sunglasses Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "acai shop",
    "label": "Acai Shop",
    "bundleRef": "food-beverage",
    "primaryKeychain": "beverage-nfc-keychain"
},{
    "id": "carpet cleaning service",
    "label": "Carpet Cleaning Service",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "cleaning-spray-nfc-keychain"
},{
    "id": "indian restaurant",
    "label": "Indian Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "asian restaurant",
    "label": "Asian Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "home theatre shop",
    "label": "Home Theatre Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "mobile phone shop",
    "label": "Mobile Phone Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "website-nfc-keychain"
},{
    "id": "party shop",
    "label": "Party Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "balloon-nfc-keychain"
},{
    "id": "dance school",
    "label": "Dance School",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "microphone-nfc-keychain"
},{
    "id": "appliance shop",
    "label": "Appliance Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "shopping centre",
    "label": "Shopping Centre",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "hamburger restaurant",
    "label": "Hamburger Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "computer shop",
    "label": "Computer Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "website-nfc-keychain"
},{
    "id": "roofer",
    "label": "Roofer",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "financial planner",
    "label": "Financial Planner",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "lighting shop",
    "label": "Lighting Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "gardener",
    "label": "Gardener",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "tree-nfc-keychain"
},{
    "id": "hotel",
    "label": "Hotel",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "laundromat",
    "label": "Laundromat",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "cleaning-spray-nfc-keychain"
},{
    "id": "sporting goods shop",
    "label": "Sporting Goods Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "computer support & services",
    "label": "Computer Support & Services",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "website-nfc-keychain"
},{
    "id": "dentistry",
    "label": "Dentistry",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "chinese restaurant",
    "label": "Chinese Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "medical centre",
    "label": "Medical Centre",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "mexican restaurant",
    "label": "Mexican Restaurant",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "sports coach",
    "label": "Sports Coach",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "golf course",
    "label": "Golf Course",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "kitchen shop",
    "label": "Kitchen Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "deli",
    "label": "Deli",
    "bundleRef": "food-beverage",
    "primaryKeychain": "chef-hat-nfc-keychain"
},{
    "id": "dentist office",
    "label": "Dentist Office",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "car wash",
    "label": "Car Wash",
    "bundleRef": "automotive",
    "primaryKeychain": "cleaning-spray-nfc-keychain"
},{
    "id": "furniture shop",
    "label": "Furniture Shop",
    "bundleRef": "retail-shopping",
    "primaryKeychain": "house-nfc-keychain"
},{
    "id": "transport services",
    "label": "Transport Services",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "garden services",
    "label": "Garden Services",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "tree-nfc-keychain"
},{
    "id": "mma",
    "label": "Mma",
    "bundleRef": "fitness-wellness",
    "primaryKeychain": "football-nfc-keychain"
},{
    "id": "mobile services",
    "label": "Mobile Services",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "acupuncture",
    "label": "Acupuncture",
    "bundleRef": "health-medical",
    "primaryKeychain": "stethoscope-nfc-keychain"
},{
    "id": "window services",
    "label": "Window Services",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "cleaning-spray-nfc-keychain"
},{
    "id": "heritage preservation",
    "label": "Heritage Preservation",
    "bundleRef": "hospitality-events-specialty",
    "primaryKeychain": "custom-nfc-keychain"
},{
    "id": "it & communication",
    "label": "It & Communication",
    "bundleRef": "home-professional-services",
    "primaryKeychain": "website-nfc-keychain"
},{
    "id": "lounge bar",
    "label": "Lounge Bar",
    "bundleRef": "food-beverage",
    "primaryKeychain": "wine-glass-nfc-keychain"
}
    ]
};
